import { createContext } from "react";

const CustomContext = createContext();

export default CustomContext;
